import React, { memo } from 'react';

import { Box, Button, Typography } from '@mui/material';
import { InfoFilledIcon, WarningTriangleIcon } from '@sharedCR/coreDesignSystem/icons';
import PropTypes from 'prop-types';

import { PREVIEW_COPY } from '../../previewGeneration.constants';
import { PreviewStepTestIds } from '../../PreviewStep.testIds';

import {
  containerStyles,
  getIconStyles,
  retryStyles,
  subtitleStyles,
  titleStyles,
} from './PreviewStatusMessage.styles';

const PreviewStatusMessage = ({ isError, errorMessage, onRetry }) => {
  const title = isError ? PREVIEW_COPY.errorTitle : PREVIEW_COPY.unavailableTitle;
  const subtitle = isError
    ? errorMessage || PREVIEW_COPY.errorSubtitle
    : PREVIEW_COPY.unavailableSubtitle;
  const testId = isError ? PreviewStepTestIds.ERROR : PreviewStepTestIds.UNAVAILABLE;

  return (
    <Box data-testid={testId} sx={containerStyles}>
      <Box sx={getIconStyles(isError)}>
        {isError ? <WarningTriangleIcon size={26} /> : <InfoFilledIcon size={26} />}
      </Box>
      <Typography sx={titleStyles} variant="bold16">
        {title}
      </Typography>
      <Typography sx={subtitleStyles} variant="regular14">
        {subtitle}
      </Typography>
      {isError && !!onRetry && (
        <Button
          data-testid={PreviewStepTestIds.RETRY_BUTTON}
          sx={retryStyles}
          variant="outlined"
          onClick={onRetry}
        >
          {PREVIEW_COPY.retryLabel}
        </Button>
      )}
    </Box>
  );
};

PreviewStatusMessage.propTypes = {
  isError: PropTypes.bool,
  errorMessage: PropTypes.string,
  onRetry: PropTypes.func,
};

export default memo(PreviewStatusMessage);
